import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'dash-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.scss']
})
export class PedidosComponent implements OnInit {
  
  private subscription: Subscription;
  public loading: boolean;
  public calcPending: number;
  public calcSeparation: number;
  public calcDeliver: number;
  public calcCanceled: number;
  public ordersStat: any = null;
  public dateSetup: any;

  constructor(private _orderService: OrderService,
    private _stateService: StatesService) { 
    this.loading = true;
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe(res => {
      this.dateSetup = res;
      this._orderService.ordersStatistics(this.dateSetup.start_date, this.dateSetup.end_date).subscribe(data => {
        this._stateService.changeOrder(data);
        this._stateService.currentOrders.subscribe(res => {
          this.ordersStat = res;
          //Calculo da porcentagem para cada caso
          //=======================================================================================
          this.calcPending = Number(((100 * this.ordersStat.num_order_pending)/this.ordersStat.num_orders).toFixed(2));
          this.calcSeparation = Number(((100 * this.ordersStat.num_order_separation)/this.ordersStat.num_orders).toFixed(2));
          this.calcDeliver = Number(((100 * this.ordersStat.num_order_delivery)/this.ordersStat.num_orders).toFixed(2));
          this.calcCanceled = Number(((100 * this.ordersStat.num_order_canceled)/this.ordersStat.num_orders).toFixed(2));        
          this.loading = false;
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
